import React, { Fragment, useState, useRef, useEffect } from 'react';
import man from '../../../assets/images/dashboard/boy-2.png';
import { LogOut, ChevronDown } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    SET_LOGIN_FLAG,
    SET_OTP_VERIFICATION,
    SET_USER_DATA,
    SET_USER_AUTHTOKEN
} from '../../../constant/actionTypes';

const formatRole = (role) => {
    if (!role) return "Administrator";
    return role.replace(/_/g, " ");
};

const UserMenu = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const menuRef = useRef(null);

    const loginUserData = useSelector((state) => state.auth?.loginUserData);

    const firstName = loginUserData?.first_name || "";
    const lastName = loginUserData?.last_name || "";
    const fullName = [firstName, lastName].filter(Boolean).join(" ") || "Admin User";
    const email = loginUserData?.email || "";
    const roleTitle = formatRole(loginUserData?.role);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLogout = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setDropdownOpen(false);

        dispatch({
            type: SET_LOGIN_FLAG,
            flag: false
        });
        dispatch({
            type: SET_OTP_VERIFICATION,
            isVerify: false
        });
        dispatch({
            type: SET_USER_DATA,
            userData: null
        });
        dispatch({
            type: SET_USER_AUTHTOKEN,
            authToken: null
        });

        try {
            localStorage.removeItem('state');
        } catch (err) {
            console.error("Failed to remove state from localStorage", err);
        }

        history.push(`${process.env.PUBLIC_URL}/login`);
    };

    return (
        <Fragment>
            <li
                ref={menuRef}
                className={`user-menu-nav-item ${dropdownOpen ? 'show' : ''}`}
            >
                <div
                    className="user-profile-trigger"
                    onClick={() => setDropdownOpen((prev) => !prev)}
                    role="button"
                    tabIndex={0}
                >
                    <div className="user-avatar-wrap">
                        <img
                            className="user-avatar-img"
                            src={man}
                            alt={fullName}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                        <span className="user-online-badge"></span>
                    </div>
                    <div className="user-details-wrap d-none d-md-flex">
                        <span className="user-display-name" title={firstName || fullName}>{firstName || "Admin"}</span>
                    </div>
                    <ChevronDown
                        size={14}
                        className={`user-chevron-icon ${dropdownOpen ? 'open' : ''}`}
                    />
                </div>

                <div className={`profile-dropdown modern-profile-dropdown ${dropdownOpen ? 'show' : ''}`}>
                    <div className="dropdown-user-header">
                        <div className="dropdown-user-avatar">
                            <img src={man} alt={fullName} />
                        </div>
                        <div className="dropdown-user-info">
                            <div className="dropdown-user-name" title={fullName}>{fullName}</div>
                            {email && <div className="dropdown-user-email" title={email}>{email}</div>}
                            <span className="dropdown-user-role-pill">{roleTitle}</span>
                        </div>
                    </div>
                    <ul className="dropdown-user-body">
                        <li>
                            <button
                                type="button"
                                className="dropdown-logout-btn"
                                onClick={handleLogout}
                            >
                                <LogOut size={16} className="logout-icon" />
                                <span>Log out</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </li>
        </Fragment>
    );
};

export default UserMenu;